
import { Loader2 } from "lucide-react";
import HistoryItem from "@/components/HistoryItem";
import { HistoryEntry } from "@/types/history";
import { getStorageDebugInfo } from "@/utils/storageUtils";

interface HistoryListProps {
  loading: boolean;
  history: HistoryEntry[];
  onDeleteHistory: (historyId: string) => Promise<void>;
}

export function HistoryList({ loading, history, onDeleteHistory }: HistoryListProps) {
  console.log("📊 HistoryList render:", { loading, historyCount: history.length });
  
  if (loading) {
    console.log("⏳ HistoryList: Showing loading state");
    return (
      <div className="flex flex-col items-center justify-center py-16">
        <Loader2 className="h-10 w-10 text-primary animate-spin mb-4" />
        <p className="text-muted-foreground">Loading history...</p>
      </div>
    );
  }

  if (history.length === 0) {
    console.log("📭 HistoryList: No history found, showing empty state");
    
    // Debug storage when no history is found
    getStorageDebugInfo();
    
    return (
      <div className="text-center py-16 glass-card rounded-2xl animate-fade-in">
        <div className="w-16 h-16 rounded-full bg-primary/10 flex items-center justify-center mx-auto mb-4">
          <Loader2 className="h-8 w-8 text-primary" />
        </div>
        <h3 className="text-lg font-medium mb-2">No history yet</h3>
        <p className="text-muted-foreground text-sm max-w-sm mx-auto">
          Start by taking a photo or uploading an image to generate creative ideas.
        </p>
        <div className="mt-4 text-xs text-muted-foreground">
          Desktop users: History is stored locally and should persist across sessions.
        </div>
      </div>
    );
  }
  
  console.log(`✅ HistoryList: Rendering ${history.length} history items`);

  return (
    <div className="space-y-2 animate-fade-in-up">
      {history.map((entry) => (
        <HistoryItem
          key={entry.id}
          id={entry.id}
          imageUrl={entry.imageUrl}
          ideas={entry.ideas}
          timestamp={new Date(entry.timestamp)}
          onDelete={onDeleteHistory}
        />
      ))}
    </div>
  );
}

export default HistoryList;
